import { gql } from '@apollo/client';

const UPDATE_COMPANY_DEFAULT_THEME = gql`mutation updateCompanyDefaultTheme($companyId: Int!, $defaultTheme:String!)
{
	companyAdminContext{
		settings{
			updateCompanyDefaultTheme(companyId:$companyId, defaultTheme:$defaultTheme)
		}
	}	
}
`;

export default UPDATE_COMPANY_DEFAULT_THEME;